<template>
  <div>
    <el-table
      v-if="showTable"
      :data="dataList"
      border
      :header-row-style="tableHeaderStyle"
      :header-cell-style="tableHeaderStyle"
      :default-sort = "{prop: 'index', order: 'ascending'}"
      empty-text="ไม่พบข้อมูล"
    >
      <el-table-column
        type="index"
        label="ลำดับ"
        header-align="center"
        align="center"
        sortable
        :width="
          widthMax < 767.98
            ? '60'
            : widthMax < 1199
            ? '60'
            : widthMax > 1200
            ? '80'
            : ''
        "
      ></el-table-column>
      <el-table-column
        prop="index"
        label="ชื่อวิชา"
        header-align="center"
        sortable
        :width="widthMax < 767.98 ? '200' : ''"
      >
        <template slot-scope="scope">
          วิชาที่ {{ scope.row.index }} {{ scope.row.name }}
        </template>
      </el-table-column>
      <el-table-column
        prop="durationTime"
        label="เปิด-ปิดวิชา"
        width="350"
        header-align="center"
        align="center"
      >
        <template slot-scope="scope"
          >{{ scope.row.durationTime.open | dateTimeThShort }} -
          {{ new Date(scope.row.durationTime.close).setHours(23,59,59) | dateTimeThShort }}</template
        >
      </el-table-column>
      
      <el-table-column
        v-if="shwoColumn == 'discussionForum'"
        prop="discussionForum"
        label="กระดานถาม - ตอบระหว่างเรียน"
        header-align="center"
        align="center"
        :width="
          widthMax < 767.98
            ? '130'
            : widthMax < 991
            ? '130'
            : widthMax < 1199
            ? '130'
            : widthMax > 1200
            ? '220'
            : ''
        "
      >
        <template slot-scope="scope">
          <span v-if="scope.row.discussion.have">
            {{ scope.row.discussion.active }}/{{ scope.row.discussion.total }}
          </span>
          <span v-else>
            -
          </span>
        </template>
      </el-table-column>
      <el-table-column
        v-if="shwoColumn == 'assignment'"
        prop="assignment"
        label="งานที่ได้รับมอบหมาย"
        header-align="center"
        align="center"
        :width="
          widthMax < 767.98
            ? '130'
            : widthMax < 991
            ? '130'
            : widthMax < 1199
            ? '130'
            : widthMax > 1200
            ? '220'
            : ''
        "
      >
        <template slot-scope="scope">
          <span v-if="scope.row.assignment.have">
            {{ scope.row.assignment.active }}/{{ scope.row.assignment.total }}
          </span>
          <span v-else>
            -
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="updatedAt"
        label="วันที่และเวลาที่อัปเดต"
        :width="
          widthMax < 767.98
            ? '160'
            : widthMax < 991
            ? '160'
            : widthMax < 1199
            ? '160'
            : widthMax > 1200
            ? '250'
            : ''
        "
        header-align="center"
        align="center"
      >
        <template slot-scope="scope">
          {{ scope.row.updatedAt | dateTimeTh }}
        </template>
      </el-table-column>
      <el-table-column label width="80" header-align="center" align="center">
        <template slot-scope="scope">
          <div class="flex-display ai-center js-center">
            <el-tooltip v-if="(shwoColumn =='discussionForum' && scope.row.discussion.have) || (shwoColumn =='assignment' && scope.row.assignment.have)" class="item" effect="dark" :content="shwoColumn =='discussionForum'?'ดูกระดานถาม - ตอบระหว่างเรียน':'ดูงานที่ได้รับหมอยหมาย'">
              <div class="box-action">
                <div
                  @click="(shwoColumn =='discussionForum')?
                    $router.push(
                      `/manage/discussion/forum?courseId=${courseId}&subjectId=${scope.row._id}`
                    )
                    :
                    $router.push(
                      `/manage/assignment?courseId=${courseId}&subjectId=${scope.row._id}`
                    )
                  "
                  class="circle-action color-bg-secondary"
                >
                  <i class="fas fa-eye"></i>
                </div>
              </div>
            </el-tooltip>
            <el-tooltip v-if="showCheckAssignment && scope.row.assignment.have" class="item" effect="dark" content="ตรวจงานที่ได้รับหมอยหมาย">
              <div  class="box-action">
                <div
                  @click="$router.push(`/manage/assignment/check/?courseId=${courseId}&subjectId=${scope.row._id}`)"
                  class="circle-action color-bg-secondary"
                >
                  <i class="fas fa-pen"></i>
                </div>
              </div>
            </el-tooltip>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { tableHeaderStyle } from "@/service/table";

export default {
  props: {
    dataList: {
      type: Array,
      default() {
        return [];
      },
    },
    courseId: {
      type: String,
      default() {
        return "";
      },
    },
    shwoColumn: {
      type: String,
      default() {
        return "";
      },
    },
    showCheckAssignment:{
      type:Boolean,
      default() {
        return false;
      },
    }
  },
  computed: {},
  data() {
    return {
      widthMax: window.innerWidth,
      showTable:true
    };
  },
  mounted() {
    window.addEventListener("resize", this.resize);
  },
  methods: {
    resize() {
      this.showTable = false
      this.widthMax= window.innerWidth
      setTimeout(() => {
        this.showTable = true
      }, 200);

    },
  },
};
</script>